import cx from 'classnames'
import {
  MonitorParseManualPassageDataResponse,
  MonitorParseManualPassageDataResponseErrors,
  MonitorParseManualPassageDataResponseWorklists,
} from '~/api/backend/pages/wellPageAPI'
import { displayCount } from '~/utils/string'
import GroupedErrorTable from '../../utils/GroupedErrorTable'
import { getRecordManualPassageParseDataErrorGroups } from './getRecordManualPassageParseDataErrorGroups'
import {
  getNumDistinctCultures,
  getNumDistinctPlates,
} from './parseDataResponseExtractors'
import RecordManualPassageWorklistPreview from './RecordManualPassageWorklistPreview'
import cs from './upload_data_step_preview.scss'

export interface UploadDataStepPreviewProps {
  className?: string
  loading: boolean
  parseDataResponse: MonitorParseManualPassageDataResponse | null
}

const UploadDataStepPreview = ({
  className,
  loading,
  parseDataResponse,
}: UploadDataStepPreviewProps) => {
  if (!loading && parseDataResponse === null) {
    return null
  }

  const renderContents = () => {
    if (loading) {
      return <div className={cs.info}>Loading preview...</div>
    }

    if (parseDataResponse === null) {
      return null
    }

    if (parseDataResponse.type === 'errors') {
      const response = parseDataResponse as MonitorParseManualPassageDataResponseErrors
      return (
        <>
          <div className={cs.errorCount}>
            {displayCount('error', response.errors.length)} with pasted data
          </div>
          <GroupedErrorTable
            className={cs.parseDataErrorTable}
            errorGroups={getRecordManualPassageParseDataErrorGroups(response)}
          />
        </>
      )
    }
    if (parseDataResponse.type === 'worklists') {
      const worklists =
        parseDataResponse as MonitorParseManualPassageDataResponseWorklists
      return (
        <>
          <div className={cs.info}>
            Record passage for{' '}
            {displayCount('culture', getNumDistinctCultures(worklists))} (
            {displayCount('plate', getNumDistinctPlates(worklists))})
          </div>
          <RecordManualPassageWorklistPreview
            worklists={worklists.data}
            plates={worklists.culture_plates}
            className={cs.table}
          />
        </>
      )
    }

    return null
  }

  return (
    <div className={cx(className, cs.uploadDataStepPreview)}>
      <div className={cs.sectionTitle}>Preview</div>
      <div className={cs.contents}>{renderContents()}</div>
    </div>
  )
}

export default UploadDataStepPreview
